<mat-toolbar class="cvv_vertical_toolbar_menu">

  <button *appHasRole="['cvv_coordinator']" mat-icon-button aria-label="dispatch" (click)="navButtonClicked('dispatch')">
    <mat-icon class="material-icons-outlined" [ngClass]="darkModeEnabled ? 'white-menu-icon' : ''" svgIcon="icon-bus"></mat-icon>
  </button>

  <button *appHasRole="['cvv_coordinator','cvv_driver']" mat-icon-button aria-label="my tasks" (click)="navButtonClicked('myTasks')">
    <mat-icon class="material-icons-outlined" [ngClass]="darkModeEnabled ? 'white-menu-icon' : ''" svgIcon="icon-tasks"></mat-icon>
  </button>

  <button *appHasRole="['cvv_coordinator','cvv_driver']" mat-icon-button aria-label="unassigned tasks" (click)="navButtonClicked('unassignedTasks')">
    <mat-icon class="material-icons-outlined" [ngClass]="darkModeEnabled ? 'white-menu-icon' : ''" svgIcon="icon-unassigned"></mat-icon>
  </button>

  <button *appHasRole="['cvv_coordinator','cvv_driver']" mat-icon-button aria-label="new task" (click)="navButtonClicked('newTask')">
    <mat-icon class="material-icons-outlined" [ngClass]="darkModeEnabled ? 'white-menu-icon' : ''" svgIcon="icon-new-task"></mat-icon>
  </button>

  <button *appHasRole="['cvv_coordinator']" mat-icon-button aria-label="manage vans" (click)="navButtonClicked('manageVans')">
    <mat-icon class="material-icons-outlined" [ngClass]="darkModeEnabled ? 'white-menu-icon' : ''" svgIcon="icon-dispatch"></mat-icon>
  </button>

  <button *appHasRole="['cvv_coordinator','cvv_driver','cvv_view_only']" mat-icon-button aria-label="search" (click)="navButtonClicked('search')">
    <mat-icon class="material-icons-outlined" [ngClass]="darkModeEnabled ? 'white-menu-icon' : ''" svgIcon="icon-search"></mat-icon>
  </button>

  <button *appHasRole="['cvv_coordinator','cvv_driver']" mat-icon-button aria-label="terminal" (click)="navButtonClicked('terminalruns')">
    <mat-icon class="material-icons-outlined" [ngClass]="darkModeEnabled ? 'white-menu-icon' : ''" svgIcon="terminal-run"></mat-icon>
  </button>

  <button *appHasRole="['cvv_coordinator','cvv_driver']" mat-icon-button aria-label="outbound" (click)="navButtonClicked('outbound')" class="outbound-style">
    <mat-icon class="material-icons-outlined rotateOutbound" [ngClass]="darkModeEnabled ? 'white-menu-icon' : ''" svgIcon="icon-airplane-menu"></mat-icon>
  </button>

  <span class="cvv_vertical_toolbar_menu_spacer"></span>

  <button *appHasRole="['cvv_coordinator','cvv_driver']" mat-icon-button aria-label="profile" (click)="navButtonClicked('profile')">
    <mat-icon class="material-icons-outlined" [ngClass]="darkModeEnabled ? 'white-menu-icon' : ''" svgIcon="icon-user"></mat-icon>
  </button>

  <button *appHasRole="['cvv_coordinator','cvv_driver','cvv_view_only']" mat-icon-button aria-label="settings" (click)="navButtonClicked('settings')">
    <mat-icon class="material-icons-outlined" [ngClass]="darkModeEnabled ? 'white-menu-icon' : ''" svgIcon="icon-cog"></mat-icon>
  </button>


</mat-toolbar>
